<template>
  <v-table>
    <tbody>
      <tr>
        <td><strong>Year:</strong></td>
        <td>
          <div>{{ year.year }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Start Date:</strong></td>
        <td>
          <div>{{ year.displayStartDate }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Launch Date:</strong></td>
        <td>
          <div>{{ year.displayLaunchDate }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Start Date:</strong></td>
        <td>
          <div>{{ year.displayTurnStart }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Deadline:</strong></td>
        <td>
          <div>{{ year.displayTurnDeadLine }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Screening Copy Deadline:</strong></td>
        <td>
          <div>{{ year.displayScreeningCopyDeadline }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In OverView Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Upload Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Upload Late Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Upload Screening Copy Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Entry Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Still/Team Video Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Release Form Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Turn In Cast and Crew Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Criteria FAQ Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Criteria Selection Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>End Date:</strong></td>
        <td>
          <div>{{ year.displayEndDate }}</div>
        </td>
      </tr>

      <tr>
        <td><strong>Theme:</strong></td>
        <td>
          <div>{{ year.theme }}</div>
        </td>
      </tr>
      <tr>
        <td><strong>Registration Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
      <tr>
        <td><strong>Registration Level Text:</strong></td>
        <td>
          <div>Edit to see</div>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>
<script setup lang="ts">
import { IYearDTO } from '@/dtos';
import { computed } from 'vue';

interface Props {
  year: IYearDTO;
}
const props = defineProps<Props>();
const year = computed(() => props.year);
</script>
